import type { PropsWithChildren } from 'react'
import { useCallback } from 'react'

import { Button, Modal, Statement } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import useTranslation from 'next-translate/useTranslation'

import type { ApolloError } from '@apollo/client'

interface EntitySwitcherErrorProps {
  /**
   * Error.
   */
  error: ApolloError | undefined
  /**
   * Handle retry.
   */
  handleRetry: () => void
}

export const EntitySwitcherError: React.FC<
  PropsWithChildren<EntitySwitcherErrorProps>
> = ({ error, handleRetry, children }) => {
  const { t } = useTranslation('manageAccounts')
  const { t: tCommon } = useTranslation('common')

  const modal = useModal()

  const handleCancel = useCallback(
    () => modal.close({ context: 'onDismiss' }),
    [modal],
  )

  if (!error) {
    return <>{children}</>
  }

  return (
    <>
      <Statement
        padded={false}
        status="error"
        title={t`switchEntity.error`}
        variant="component"
      />
      <Modal.Footer className="mt-6" variant="stretch-fraction" dense>
        <Button onClick={handleCancel} variant="secondary">
          {tCommon('cancel')}
        </Button>
        <Button onClick={handleRetry} variant="primary">
          {tCommon('tryAgain')}
        </Button>
      </Modal.Footer>
    </>
  )
}
